module.exports = __webpack_public_path__ + "static/media/money-pence-two.9d1a4762.svg";